import { render, staticRenderFns } from "./account.index.vue?vue&type=template&id=5864c1e2&"
import script from "./account.index.vue?vue&type=script&lang=js&"
export * from "./account.index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports